<a routerLink="/how-to-watch">
  <h1>Watch on your TV</h1>
  <div class="logos">
    <img class="chromecast" alt="Chromecast" src="/assets/air_chromecast.png" />
    <img class="airplay" alt="Airplay" src="/assets/airplay.png" />
    <img *ngIf="exposeAppleTV" class="apple-tv" alt="Apple TV" src="/assets/apple-tv-logo.png" />
    <img *ngIf="exposeAndroidTV" class="android-tv" alt="Android TV" src="/assets/android-tv-logo_fit.png" />
  </div>
</a>